export enum SquareMeterTypeEnum {
  MEASURE = "MEASURE",
  NUMBER_OF_UNIT = "NUMBER_OF_UNIT",
  NUMBER_OF_UNIT_TOTAL = "NUMBER_OF_UNIT_TOTAL",
}

